import { useAuthState } from "@/modules/auth/presentation/model/useAuthState";
import { AdminBrandLogo } from "@/shared/ui/AdminBrandLogo";
import { Loader } from "@/shared/ui/Loader";

import { Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export function AuthLayout() {
  const { isLoading, isAuthenticated } = useAuthState();
  const navigate = useNavigate({ from: "/auth" });

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/app/dashboard" });
    }
  }, [isLoading, isAuthenticated, navigate]);

  const shell = (
    <>
      <div className="from-mineral-gold/10 pointer-events-none absolute inset-0 bg-gradient-to-br via-transparent to-mineral-gold/10" />
      <div className="bg-mineral-gold/10 pointer-events-none absolute -top-16 -right-16 size-72 rounded-full blur-3xl" />
      <div className="bg-mineral-navy/20 pointer-events-none absolute bottom-10 -left-20 size-56 rounded-full blur-2xl" />

      <div className="relative z-10 mx-auto flex w-full max-w-md flex-col justify-center space-y-2 px-4 py-8 sm:p-8">
        <div className="mb-8 flex flex-col items-center justify-center text-center">
          <AdminBrandLogo size="lg" />
          <p className="text-mineral-off-white/70 mt-6 font-sans text-sm leading-relaxed">
            ລະບົບຈັດການຫຼັງບ້ານ — ສາຂາ ສິນຄ້າ ອໍເດີ້
          </p>
        </div>
        <Outlet />
      </div>
    </>
  );

  if (isLoading) {
    return (
      <div className="auth-page relative flex h-svh max-w-none items-center justify-center overflow-hidden bg-background transition-colors duration-300 ease-in-out">
        <Loader />
      </div>
    );
  }

  return (
    <div className="auth-page relative flex h-svh max-w-none items-center justify-center overflow-hidden bg-background transition-colors duration-300 ease-in-out">
      {shell}
    </div>
  );
}
